import Vue from 'vue'

// axios
import axios from 'axios'
import { $urlConfig } from '@themeConfig'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: $urlConfig.apiBaseURL,
  timeout: 10000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
